module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-honda.60cb1386.png";